import { MINI_HOST_APP_FLAGS } from './miniHostAppFlags';
import type { MiniHostAppFeature } from './schema/MiniHostAppFeature';
import type { MiniHostAppFlagControl } from './schema/MiniHostAppFlagControl';

export function getFlagDefaults(flagName: MiniHostAppFeature): MiniHostAppFlagControl {
    return MINI_HOST_APP_FLAGS[flagName];
}
